import React, { useState, useEffect, useRef, Suspense, lazy } from "react";
import { Link } from "react-router-dom";
import Loader from "./Loader";
import APIs,{ _GetRequest } from "../../api";
const Youtube = lazy(() => import("./Youtube"));

function HomePart2() {
  const ref = useRef(null);
  const [homeSet2, setHomeSet2Data] = useState({});
  const [loader, setLoader] = useState(false);

 
  useEffect(() => {
    setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting === true) {
            (async()=>{
              try {
                setLoader(true)
               let respHomeData2 = await _GetRequest(APIs.home_api_set2);
               if(respHomeData2.data){
                 setLoader(false);
                 setHomeSet2Data(respHomeData2.data)
               }
              } catch (error) {
                console.log(error?.message);
                setLoader(false);
              }
            })()
            observer.disconnect();
          }
        },
        { root: null, rootMargin: "0px", threshold: 0.1 }
      );
      observer.observe(ref.current);
    }, 500);
  }, []);
  
  useEffect(() => {
    if (homeSet2?.dsci_initiative) {
      const el1_initiative = document.getElementById("initiative-section-body");
      if (el1_initiative) {
        el1_initiative.innerHTML = homeSet2?.dsci_initiative?.html;
      }
    }
    if (homeSet2?.dsci_membership) {
      const el_dsci_m = document.getElementById("dsci-membership-section-body");
      if (el_dsci_m) {
        el_dsci_m.innerHTML = homeSet2?.dsci_membership?.html;
        const box = document.getElementsByClassName("dsci-members-counters");
        
        if (box) {
          //const counters = document.querySelectorAll(".members-circle");
          const container = document.querySelector(".memebers-count");
          let activated = false;
          
          //debugger
          if (container.dataset.count) {
            window.addEventListener("scroll", () => {
              const scrollY = window.scrollY; // Use scrollY instead of pageYOffset
              if (
                scrollY > container.offsetTop - container.offsetHeight - 200 &&
                activated === false
              ) {
                // counters.forEach((counter) => {
                  container.innerText = 0;
                  let count = 0;
                  const target = parseInt(container.dataset.count);
                  function updateCount() {
                    if (count < target) {
                      count++;
                      container.innerText = count;
                      setTimeout(updateCount, 10);
                    } else {
                      container.innerText = target;
                    }
                  }
                  updateCount();
                  activated = true;
                // });
              } else if (
                scrollY < container.offsetTop - container.offsetHeight - 500 ||
                (scrollY === 0 && activated === true)
              ) {
                //counters.forEach((counter) => {
                  container.innerText = 0;
                //});
                activated = false;
              }
            }
          );
          } 
          else {
            console.error("Element .members-counters not found");
          }
        }
      }
    }
    if (homeSet2?.dsci_coe) {
      const el_resource_c = document.getElementById(
        "center-of-excellence-block"
      );
      if (el_resource_c) {
        el_resource_c.innerHTML = homeSet2?.dsci_coe?.html;
      }
    }
    if (homeSet2?.flagship_events) {
      const flag = document.getElementById("flagship-section-body");
      if (flag) {
        flag.innerHTML = homeSet2?.flagship_events?.html;
      }
    }

    if (homeSet2?.podcast) {
      const twitter = document.getElementById("twitter");
      if (twitter) {
        twitter.innerHTML = homeSet2?.podcast?.html;
      }
    }

    // setTimeout(() => {
    //   init3();
    //   init4();
    //   init6();
    //   init7();
    // }, 500);
  }, [homeSet2]);
  
  return (
    <React.Fragment>
      <div ref={ref}>
        {loader ? (
          <Loader />
        ) : (
          <React.Fragment>
            <div className="home-our-initiative-section-div" id="initiative-section-body"></div>
            <div className="container-fluid dsci-membership-section-body" id="dsci-membership-section-body"></div>
            {loader ? (
              <Loader />
            ) : (
              <React.Fragment>
              { (homeSet2?.resource_center?.thumbnail && homeSet2?.resource_center?.title && homeSet2?.resource_center?.body)?<div className="box-8">
                  <div className="container-fluid">
                    <div className="container-main">
                    <div className="row">
                        <div className="col-lg-12 d-lg-none d-block d-sm-block d-md-block">
                          <div className="w-100 box-11">
                            <h4>Resource Center</h4>
                            <p>{homeSet2?.resource_center?.body}</p>
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-12">
                          <div className="box-10 ">
                            <div className="row">
                              <div className="col-lg-6 col-sm-6">
                                <img
                                  src={homeSet2?.resource_center?.thumbnail}
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                              <div className="col-lg-6 col-sm-6">
                                <h6>Latest Report</h6>
                                {loader ? (
                                  <Loader />
                                ) : (
                                  <React.Fragment>
                                    <h4> {homeSet2?.resource_center?.title.substring( 0, 200 ) + "...."} </h4>
                                    <p> {homeSet2?.resource_center?.body?.substring( 0, 220 ) + "...."} </p>
                                  </React.Fragment>
                                )}
                                <Link to={`/resource${homeSet2?.resource_center?.url}`} className="explore-btn skew" >
                                  Explore now{" "}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-5 d-none d-md-none d-lg-block">
                          <div className="w-100 box-11">
                            <h4>Resource Center</h4>
                            <p>{homeSet2?.resour_cecenter_desc}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="container-fluid" style={{ position: "relative" }}>
                    <div className="container-main">
                      <div className="box-14-1 ">
                        <div className="row ps-6 justify-content-end">
                          <div className="col-lg-3 col-sm-6 col-6">
                            <Link to="/knowledge-center/study-and-reports">
                              {" "}
                              <div className="box-12 wobble-horizontal text-center">
                                <img src={process.env.PUBLIC_URL+"/assets/img/case 1.webp"} alt="" />
                                <p>Studies & Reports</p>
                              </div>
                            </Link>
                          </div>
                          <div className="col-lg-3 col-sm-6 col-6">
                            <Link to="/knowledge-center/whitepapers">
                              {" "}
                              <div className="box-12 wobble-horizontal text-center">
                                <img src={process.env.PUBLIC_URL + "/assets/img/case 2.webp"} alt="case-2" />
                                <p>Whitepapers</p>
                              </div>
                            </Link>
                          </div>
                        </div>
                        <div className="row ps-6 justify-content-end box-14-2">
                          <div className="col-lg-3 col-sm-6 col-6">
                            <Link to="/knowledge-center/newsletters">
                              <div className="box-12 wobble-horizontal text-center">
                                <img src={process.env.PUBLIC_URL + "/assets/img/newsletter(1).webp"} alt="case-3" />
                                <p>Newsletters</p>
                              </div>
                            </Link>
                          </div>
                          <div className="col-lg-3 col-sm-6 col-6">
                            <Link to="/knowledge-center/pov">
                              <div className="box-12 wobble-horizontal text-center">
                                <img src={process.env.PUBLIC_URL + "/assets/img/case 2(2).webp"} alt="case-4" />
                                <p>PoV Papers</p>
                              </div>
                            </Link>
                          </div>
                          <div className="col-lg-3 col-sm-12 col-12">
                            <Link to="/advisory">
                              <div className="box-12 wobble-horizontal text-center">
                                <img src={process.env.PUBLIC_URL +  "/assets/img/case 2(1).webp"} alt="case-5" />
                                <p>Advisories</p>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>:""}
              </React.Fragment>
            )}
            <div className="container-fluid center-of-excellence-block" id="center-of-excellence-block" ></div>
            <div className="box-21">
              {homeSet2?.advisory?.advisory_description ? <div className="container-fluid">
                <div className="container-main">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="container-fluid flagship-section-body" id="flagship-section-body" ></div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="box-21-6">
                        <h4>Threat Intelligence & Research</h4>
                        <p className="mb-0"> { homeSet2?.advisory?.advisory_description } </p>
                        <div className="box-3">
                          <div className="row">
                            <div className="col-lg-4 col-sm-5">
                              <img src={homeSet2?.advisory?.advisory?.thumbnail} alt="" className="img-fluid" />
                            </div>
                            <div className="col-lg-6 col-sm-7">
                              <div className="w-100 box-3-box">
                                <h3>
                                  <img src={ process.env.PUBLIC_URL + "/assets/img/date 1.svg"} alt="" className="me-2 calendar-icon" />
                                  <span> {" "} {homeSet2?.advisory?.advisory?.published_date } </span>
                                </h3>
                                <a href={homeSet2?.flagshblock?.advisory?.field_document} rel="noopener noreferrer" target="_blank" >
                                  <h4> { homeSet2?.advisory?.advisory?.title } </h4>
                                </a>
                                <a href={homeSet2?.advisory?.advisory?.url} rel="noopener noreferrer" target="_blank" >
                                  <div className="stakeholders-box-2-1 p-3 mt-5">
                                    <div className="float-start stakeholders-box-2-1-1 strip">
                                      <img src={ process.env.PUBLIC_URL + "/files/content/media/images/2023/pdf-icon.webp" } alt="" />
                                      <strong>Download</strong>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <Link to="/advisory/threat-intel " className="threat skew mt-0" >
                          View All{" "}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>:""}
            </div>
            <Suspense fallback={<Loader />}>
              <Youtube />
            </Suspense>
            {/* Follow Us & Media Center (Press Release, Media Coverage ) */}
            <div className="box-24 ">
              <div className="container-fluid">
                <div className="container-main">
                  <div className="row">
                    <div className="col-lg-4 d-flex align-items-stretch">
                      <div className="box-23-2">
                        <h3>From the blog</h3>
                        {homeSet2?.blog?.map((vlog, index) => {
                          return (
                            <React.Fragment>
                              <div className="blog float transition-a1" key={index} >
                                <h5>
                                  <img src={ process.env.PUBLIC_URL + "/assets/img/date 1.svg" } className="me-2 calendar-icon" alt="" />
                                  {vlog?.timestamp}
                                </h5>
                                <h4>
                                  <a href={vlog?.url} target="_blank" style={{ textDecoration: "none" }} rel="noopener noreferrer" > {vlog?.title} </a>
                                </h4>
                                <p>{vlog?.body?.substring(0, 100) + "...."}</p>
                              </div>
                            </React.Fragment>
                          );
                        })}
                        <a href="/dsci-blogs" target="_blank" className="threat skew mt-0 float-start" rel="noopener noreferrer" >
                          View All Blog
                        </a>
                      </div>
                    </div>
                    <div className="col-md-12 d-block mt-5 d-sm-block d-md-none">
                      <div className="br-white "></div>
                    </div>
                    <div className="col-lg-4 d-flex align-items-stretch">
                      <div className="box-24-2">
                        <h3>Media Centre</h3>
                        <div className="">
                          <ul className="nav nav-tabs" id="myTab" role="tablist" >
                            <li className="nav-item actived" role="presentation" >
                              <button
                                className="nav-link active"
                                id="home-tab2"
                                data-bs-toggle="tab"
                                data-bs-target="#home2"
                                type="button"
                                role="tab"
                                aria-controls="home2"
                                aria-selected="true"
                              >
                                Press Release
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link"
                                id="profile-tab2"
                                data-bs-toggle="tab"
                                data-bs-target="#profile2"
                                type="button"
                                role="tab"
                                aria-controls="profile2"
                                aria-selected="false"
                              >
                                Media Coverage
                              </button>
                            </li>
                          </ul>
                        </div>
                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="home2"
                            role="tabpanel"
                            aria-labelledby="home-tab"
                          >
                            {homeSet2?.press_release?.map(
                              (press_release, index) => {
                                if (press_release?.title) {
                                  const press_rel = document.getElementById( "press_release_p" + index );
                                  if (press_rel) {
                                    if (
                                      press_release.title.length <= 30 ||
                                      press_release.title.length <= 33
                                    ) {
                                      press_rel.innerHTML =
                                        press_release?.title.length >=
                                        100
                                          ? press_release?.title.substring(
                                              0,
                                              150
                                            ) + "...."
                                          : press_release?.title;
                                    } else {
                                      press_rel.innerHTML =
                                        press_release?.title.length >=
                                        100
                                          ? press_release?.title.substring(
                                              0,
                                              200 - press_release.title.length
                                            ) + "...."
                                          : press_release?.title;
                                    }
                                  }
                                }
                                return (
                                  <div className="blog mb-5 float transition-a1" key={index} >
                                    <h5>
                                      <img
                                        src={ process.env.PUBLIC_URL + "/assets/img/date 1.svg" }
                                        className="me-2 calendar-icon"
                                        alt=""
                                      />
                                      {press_release?.published_date}
                                    </h5>
                                    <h4>
                                      <a href={press_release?.url} target="_blank" rel="noopener noreferrer" >
                                        {press_release?.title}
                                      </a>
                                    </h4>
                                  </div>
                                );
                              }
                            )}
                            <Link to={"/media-centre/press-releases"} className="threat skew mt-0" >
                              View All
                            </Link>
                          </div>
                          <div
                            className="tab-pane fade"
                            id="profile2"
                            role="tabpanel"
                            aria-labelledby="profile-tab"
                          >
                            {homeSet2?.media_coverage?.map(
                              (media_center, index) => {
                                //console.log("media", media_center)
                                if (media_center?.title) {
                                  const media_c = document.getElementById( "media_center_p" + index );
                                  if (media_c) {
                                    if (
                                      media_center.title.length <= 30 ||
                                      media_center.title.length <= 33
                                    ) {
                                      media_c.innerHTML =
                                        media_center?.title.length >=
                                        100
                                          ? media_center?.title.substring(
                                              0,
                                              150
                                            ) + "...."
                                          : media_center?.title;
                                    } else {
                                      media_c.innerHTML =
                                        media_center?.title.length >=
                                        100
                                          ? media_center?.title.substring(
                                              0,
                                              200 - media_center.title.length
                                            ) + "...."
                                          : media_center?.title;
                                    }
                                  }
                                }
                                return (
                                  <div className="blog mb-5 float transition-a1" key={index} >
                                    <h5>
                                      <img src={ process.env.PUBLIC_URL + "/assets/img/date 1.svg" } className="me-2 calendar-icon" alt={media_center.title} />
                                      {media_center?.published_date}
                                    </h5>
                                    <h4>
                                      <a href={media_center?.url.replace( "backend/sites/default/", "" )} target="_blank" rel="noopener noreferrer" >
                                        {media_center.title}
                                      </a>
                                    </h4>
                                  </div>
                                );
                              }
                            )}
                            <Link to={"/media-centre/media-coverage"} className="threat skew mt-0" >
                              View All
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 d-flex align-items-stretch">
                      <div id="twitter" className="w-100"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
}

export default HomePart2;
